import * as dateFnsLocales from 'date-fns/locale';
import { registerLocale } from 'react-datepicker';

const FALLBACK_LOCALE_KEY = 'enUS';

/**
 * API language `code` → date-fns/locale export name.
 * Codes match client/lang/list (and DB lang + optional region).
 * Missing date-fns locales intentionally omitted → fallback to enUS.
 */
export const LANG_TO_DATE_FNS = {
  af: 'af',
  ar: 'ar',
  az: 'az',
  bg: 'bg',
  bn: 'bn',
  bs: 'bs',
  ca: 'ca',
  cs: 'cs',
  cy: 'cy',
  da: 'da',
  de: 'de',
  el: 'el',
  en: 'enUS',
  'en-au': 'enAU',
  'en-ca': 'enCA',
  'en-gb': 'enGB',
  eo: 'eo',
  es: 'es',
  et: 'et',
  eu: 'eu',
  fa: 'faIR',
  fi: 'fi',
  fr: 'fr',
  'fr-ca': 'frCA',
  gl: 'gl',
  gu: 'gu',
  he: 'he',
  hi: 'hi',
  hr: 'hr',
  hu: 'hu',
  hy: 'hy',
  is: 'is',
  it: 'it',
  ja: 'ja',
  kk: 'kk',
  km: 'km',
  ko: 'ko',
  lt: 'lt',
  lv: 'lv',
  mn: 'mn',
  ms: 'ms',
  nb: 'nb',
  nl: 'nl',
  no: 'nb',
  oz: 'uz', // Uzbek Latin
  pl: 'pl',
  pt: 'pt',
  'pt-br': 'ptBR',
  ro: 'ro',
  ru: 'ru',
  sk: 'sk',
  sl: 'sl',
  sr: 'sr',
  'sr-latn': 'srLatn',
  sv: 'sv',
  th: 'th',
  tr: 'tr',
  uk: 'uk',
  uz: 'uzCyrl', // Uzbek Cyrillic (Latin is `oz`)
  vi: 'vi',
  zh: 'zhCN',
  'zh-cn': 'zhCN',
};

export const normalizeLangCode = (code) =>
  String(code || 'en')
    .toLowerCase()
    .replace(/_/g, '-');

export const getDateFnsLocaleKey = (code) => {
  const normalized = normalizeLangCode(code);
  const key = LANG_TO_DATE_FNS[normalized];

  if (key && dateFnsLocales[key]) {
    return key;
  }

  return FALLBACK_LOCALE_KEY;
};

export const getDateFnsLocale = (code) =>
  dateFnsLocales[getDateFnsLocaleKey(code)] || dateFnsLocales[FALLBACK_LOCALE_KEY];

/**
 * Registers the locale for react-datepicker under the API language code
 * and returns that code for the DatePicker `locale` prop.
 */
export const ensureDatePickerLocale = (code) => {
  const normalized = normalizeLangCode(code);
  registerLocale(normalized, getDateFnsLocale(normalized));
  return normalized;
};
